import { Provider } from "@angular/core";
import { ErrorParsers } from "./ErrorParsers";
import {
    BloqueNoExisteParser,
    EncuestaInvalidaParser,
    MinimoMenorIgualMaximoParser,
    NoModificarProcesadoParser,
    PuntosExtraParser,
    SaltoNoPermitidoParser,
    SiguientePreguntaMalParser,
    TextoRequeridoParser,
    PreguntaNoEstaEncuestaParser,
    ArchivoCasosVacioParser,
    ArchivoCuotasVacioParser,
    ColumnaUserNseFaltanteParser,
    PaisRequeridoPonderarParser,
    PaisSinNivelesNseParser,
    PiramideExistenteParser,
    PaisSinPiramideNseParser
} from "./parsers";
import { CampoVacioParser } from "./parsers/CampoVacioParser";
import { UrlConErrorParser } from "./parsers/UrlConErrorParser";
import { ErrorParserToken } from "./tokens/ErrorParserToken";

export const erroresProviders: Provider[] = [
    { provide: ErrorParserToken, useClass: BloqueNoExisteParser, multi: true },
    { provide: ErrorParserToken, useClass: TextoRequeridoParser, multi: true },
    { provide: ErrorParserToken, useClass: MinimoMenorIgualMaximoParser, multi: true },
    { provide: ErrorParserToken, useClass: SaltoNoPermitidoParser, multi: true },
    { provide: ErrorParserToken, useClass: NoModificarProcesadoParser, multi: true },
    { provide: ErrorParserToken, useClass: PuntosExtraParser, multi: true },
    { provide: ErrorParserToken, useClass: SiguientePreguntaMalParser, multi: true },
    { provide: ErrorParserToken, useClass: EncuestaInvalidaParser, multi: true },
    { provide: ErrorParserToken, useClass: PreguntaNoEstaEncuestaParser, multi: true },
    { provide: ErrorParserToken, useClass: ArchivoCasosVacioParser, multi: true },
    { provide: ErrorParserToken, useClass: ArchivoCuotasVacioParser, multi: true },
    { provide: ErrorParserToken, useClass: ColumnaUserNseFaltanteParser, multi: true },
    { provide: ErrorParserToken, useClass: PaisRequeridoPonderarParser, multi: true },
    { provide: ErrorParserToken, useClass: PaisSinNivelesNseParser, multi: true },
    { provide: ErrorParserToken, useClass: PiramideExistenteParser, multi: true },
    { provide: ErrorParserToken, useClass: CampoVacioParser, multi: true },
    { provide: ErrorParserToken, useClass: PaisSinPiramideNseParser, multi: true },
    { provide: ErrorParserToken, useClass: UrlConErrorParser, multi: true },
    ErrorParsers
];
